import React from "react";

const ArticleSkeleton = () => {
  return (
    <div
      style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.10)" }}
      className="animate-pulse flex flex-col gap-[12px] p-[24px] rounded-[24px] bg-gray-200 w-full h-full"
    >
      <div className="flex flex-col md:flex-row gap-[24px]">
        <div className="flex flex-col gap-[12px] bg-center">
          <div className="w-[184px] h-[184px]">
            <div className="rounded-[24px] bg-gray-400 bg-no-repeat object-cover w-[184px] h-[184px]" />
          </div>
          <div className="flex justify-between items-center">
            <span className="w-[100px]"></span>
          </div>
        </div>
        <div className="flex flex-col gap-[12px]">
          <span className="bg-gray-400 h-[10px] w-[160px]"></span>
          <span className="bg-gray-400 h-[10px] w-[220px]"></span>
        </div>
      </div>
    </div>
  );
};

export default ArticleSkeleton;
